import React from "react";

import PropTypes from "prop-types";

import { useBootstrap } from "components/store/source";

import {
  GoogleMap,
  useLoadScript,
} from "vendor/@react-google-maps/api/reactgooglemapsapi.esm";

import CustomMarker from "./CustomMarker";
import mapStyle from "./map_style.json";

const googleMapsLibraries = ["places"];

const defaultMapOptions = {
  streetViewControl: false,
  styles: mapStyle,
  mapTypeControl: false,
  clickableIcons: false,
  scrollwheel: false,
  fullscreenControl: false,
  gestureHandling: "greedy",
  zoomControl: true,
};

function StyledMap({ center, children, zoom, containerClass, mapClass }) {
  const { googleMapsApiKey } = useBootstrap();

  const { isLoaded: isMapLoaded } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries: googleMapsLibraries,
  });

  if (isMapLoaded) {
    return (
      <GoogleMap
        zoom={zoom}
        center={center}
        mapContainerClassName={containerClass}
        options={defaultMapOptions}
        styles={mapClass}
      >
        {children}
      </GoogleMap>
    );
  }

  return null;
}

StyledMap.Marker = CustomMarker;

StyledMap.propTypes = {
  containerClass: PropTypes.string,
  mapClass: PropTypes.string,
  zoom: PropTypes.number,
  children: PropTypes.node,
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
};

StyledMap.defaultProps = {
  mapClass: null,
  containerClass: null,
  zoom: 14,
  children: null,
};

export default StyledMap;
